// extracted by mini-css-extract-plugin
module.exports = {"blocREDLWrapper":"BlocREDLWrapper_blocREDLWrapper__X7_TK","blocREDLContent":"BlocREDLWrapper_blocREDLContent__wd_1E"};